/* ASD Cart Drawer — Violet Gray
 * Self-contained cart drawer: open/close, qty + remove, discount codes, gift note,
 * reward progress bar (free shipping + free gift with auto add/remove), suggested products.
 * The drawer markup is rendered by sections/ASD-Cart-Drawer.liquid and re-fetched through the
 * Section Rendering API after every change, so Liquid stays the single source of truth.
 */
(function () {
  if (window.__asdCartLoaded) return;
  window.__asdCartLoaded = true;

  var SECTION_ID = 'asd-cart-drawer';
  var queue = Promise.resolve();
  var lastFocus = null;
  var msgTimer = null;
  var selfDispatch = false;

  function getRoot() { return document.getElementById('asd-cart'); }
  function getInner() { var r = getRoot(); return r ? r.querySelector('[data-asdc-inner]') : null; }
  function getConfig() {
    var r = getRoot();
    var el = r && r.querySelector('[data-asdc-config]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function rate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && isFinite(r) ? r : 1;
  }
  function money(cents) {
    var r = getRoot();
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || (r && r.dataset.currency) || 'AUD';
    var whole = Math.round(cents) % 100 === 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(whole ? 0 : 2); }
  }
  function runExclusive(fn) {
    queue = queue.then(fn, fn).catch(function (e) { if (window.console) console.error(e); });
    return queue;
  }
  function setBusy(on) { var r = getRoot(); if (r) r.classList.toggle('is-busy', !!on); }

  /* ── Cart API ───────────────────────────────────────────── */
  function getCart() {
    return fetch('/cart.js?t=' + Date.now(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function notifyChange() {
    selfDispatch = true;
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    selfDispatch = false;
  }

  /* ── Free gift (auto add / remove) ──────────────────────── */
  function giftThresholdCents() {
    var r = getRoot();
    return Math.round(parseFloat(r.dataset.giftThreshold) * 100 * rate());
  }
  function syncGift(cart) {
    var r = getRoot();
    if (!r || r.dataset.giftEnabled !== 'true') return Promise.resolve(cart);
    var gv = parseInt(r.dataset.giftVariant, 10);
    if (!gv || r.dataset.giftAvailable !== 'true') return Promise.resolve(cart);

    var giftLines = cart.items.filter(function (i) { return i.variant_id === gv; });
    var giftValue = giftLines.reduce(function (a, i) { return a + i.final_line_price; }, 0);
    var others = cart.items.length - giftLines.length;
    var subtotal = cart.items_subtotal_price - giftValue;
    var eligible = others > 0 && subtotal >= giftThresholdCents();

    if (eligible && giftLines.length === 0) {
      return post('/cart/add.js', { items: [{ id: gv, quantity: 1, properties: { _asd_free_gift: 'true' } }] })
        .then(function () { return getCart(); });
    }
    if (eligible && (giftLines.length > 1 || giftLines[0].quantity !== 1)) {
      return post('/cart/change.js', { id: giftLines[0].key, quantity: 1 }).then(function (res) { return res.ok ? res.json() : cart; });
    }
    if (!eligible && giftLines.length) {
      var chain = Promise.resolve(cart);
      giftLines.forEach(function (l) {
        chain = chain.then(function () { return post('/cart/change.js', { id: l.key, quantity: 0 }).then(function (res) { return res.ok ? res.json() : cart; }); });
      });
      return chain;
    }
    return Promise.resolve(cart);
  }

  /* ── Rendering ──────────────────────────────────────────── */
  function refresh() {
    var r = getRoot();
    if (!r) return Promise.resolve();
    var inner = getInner();
    var scroller = inner && inner.querySelector('[data-asdc-scroll]');
    var track = inner && inner.querySelector('[data-asdc-track]');
    var keep = {
      top: scroller ? scroller.scrollTop : 0,
      track: track ? track.scrollLeft : 0,
      open: inner ? Array.prototype.map.call(inner.querySelectorAll('.asdc-ext'), function (d) { return d.open; }) : []
    };
    var url = window.location.pathname + '?section_id=' + SECTION_ID + '&t=' + Date.now();
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-asdc-inner]');
        if (!fresh || !inner) return;
        inner.replaceWith(fresh);
        var s = fresh.querySelector('[data-asdc-scroll]');
        if (s) s.scrollTop = keep.top;
        var t = fresh.querySelector('[data-asdc-track]');
        if (t) t.scrollLeft = keep.track;
        Array.prototype.forEach.call(fresh.querySelectorAll('.asdc-ext'), function (d, i) { if (keep.open[i]) d.open = true; });
        updateProgress();
      });
  }

  function updateProgress() {
    var r = getRoot();
    var inner = getInner();
    if (!r || !inner) return;
    var blocks = inner.querySelectorAll('[data-asdc-progress]');
    if (!blocks.length) return;
    var cfg = getConfig();
    cfg.msgShipBefore = cfg.msgShipBefore || "You're {amount} away from free shipping";
    cfg.msgGiftBefore = cfg.msgGiftBefore || 'Free shipping unlocked! Add {amount} more for a free gift';
    cfg.msgShipSuccess = cfg.msgShipSuccess || "You've unlocked free shipping";
    cfg.msgComplete = cfg.msgComplete || "You've unlocked free shipping + a free gift";
    cfg.labelShip = cfg.labelShip || 'Free shipping';
    cfg.labelGift = cfg.labelGift || 'Free gift';
    var total = parseInt(inner.dataset.cartTotal, 10) || 0;
    var k = rate();
    var ms = [];
    if (r.dataset.shipEnabled === 'true') ms.push({ t: 'ship', amt: Math.round(parseFloat(r.dataset.shipThreshold) * 100 * k) });
    if (r.dataset.giftEnabled === 'true') ms.push({ t: 'gift', amt: Math.round(parseFloat(r.dataset.giftThreshold) * 100 * k) });
    if (!ms.length) return;
    ms.sort(function (a, b) { return a.amt - b.amt; });
    var max = ms[ms.length - 1].amt || 1;
    var pct = Math.max(0, Math.min(100, (total / max) * 100));
    var next = null;
    for (var i = 0; i < ms.length; i++) { if (total < ms[i].amt) { next = ms[i]; break; } }

    var text;
    if (!next) {
      text = ms[ms.length - 1].t === 'gift' ? cfg.msgComplete : cfg.msgShipSuccess;
    } else {
      var shipOn = ms.some(function (m) { return m.t === 'ship'; });
      if (next.t === 'ship') text = cfg.msgShipBefore;
      else text = shipOn ? cfg.msgGiftBefore : "You're {amount} away from a free gift";
    }
    var amount = next ? money(next.amt - total) : '';
    var html = escapeHtml(text || '').replace('{amount}', '<strong>' + escapeHtml(amount) + '</strong>');

    Array.prototype.forEach.call(blocks, function (b) {
      var msg = b.querySelector('[data-asdc-prog-msg]');
      if (msg) msg.innerHTML = html;
      var fill = b.querySelector('[data-asdc-prog-fill]');
      if (fill) fill.style.width = pct + '%';
      ms.forEach(function (m) {
        var left = (m.amt / max) * 100;
        var mark = b.querySelector('[data-asdc-mark="' + m.t + '"]');
        if (mark) { mark.style.left = left + '%'; mark.classList.toggle('is-met', total >= m.amt); }
        var label = b.querySelector('[data-asdc-label="' + m.t + '"]');
        if (label) {
          label.style.left = left + '%';
          label.textContent = (m.t === 'ship' ? cfg.labelShip : cfg.labelGift);
          label.title = money(m.amt);
          label.classList.toggle('is-met', total >= m.amt);
          label.classList.toggle('is-end', left > 85);
        }
      });
    });
  }

  /* ── Open / close ───────────────────────────────────────── */
  function open() {
    var r = getRoot();
    if (!r) return;
    lastFocus = document.activeElement;
    r.classList.add('is-open');
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('asdc-lock');
    updateProgress();
    var panel = r.querySelector('.asdc__panel');
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
  }
  function close() {
    var r = getRoot();
    if (!r) return;
    r.classList.remove('is-open');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('asdc-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function showMsg(text, type) {
    var el = getRoot() && getRoot().querySelector('[data-asdc-msg]');
    if (!el || !text) return;
    el.textContent = text;
    el.classList.toggle('is-ok', type === 'ok');
    el.hidden = false;
    clearTimeout(msgTimer);
    msgTimer = setTimeout(function () { el.hidden = true; }, 4500);
  }

  /* ── Actions ────────────────────────────────────────────── */
  function afterChange(message, type) {
    return refresh().then(function () {
      if (message) showMsg(message, type);
      notifyChange();
    });
  }
  function reportError(e) {
    setBusy(false);
    showMsg(getConfig().errorGeneric);
    if (window.console) console.error(e);
  }

  function changeLine(key, qty) {
    return runExclusive(function () {
      setBusy(true);
      var message = null;
      return post('/cart/change.js', { id: key, quantity: qty })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) { message = data.description || data.message; return getCart(); }
            return data;
          });
        })
        .then(syncGift)
        .then(function () { return afterChange(message); })
        .then(function () { setBusy(false); })
        .catch(reportError);
    });
  }

  function addVariant(id, btn) {
    return runExclusive(function () {
      setBusy(true);
      if (btn) btn.disabled = true;
      var message = null;
      return post('/cart/add.js', { id: parseInt(id, 10), quantity: 1 })
        .then(function (res) {
          return res.json().then(function (data) { if (!res.ok) message = data.description || data.message; });
        })
        .then(getCart)
        .then(syncGift)
        .then(function () { return afterChange(message); })
        .then(function () { setBusy(false); })
        .catch(function (e) { if (btn) btn.disabled = false; reportError(e); });
    });
  }

  function applyCode(code) {
    code = (code || '').trim();
    if (!code) return Promise.resolve();
    return runExclusive(function () {
      setBusy(true);
      var message = null, type = null;
      return getCart().then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
          message = 'That code is already applied';
          return cart;
        }
        return post('/cart/update.js', { discount: codes.concat(code).join(',') })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var found = (data.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
            if (!found || !found.applicable) {
              message = "That code can't be applied to your bag";
              return post('/cart/update.js', { discount: codes.join(',') }).then(function (r) { return r.json(); });
            }
            message = 'Discount applied'; type = 'ok';
            return data;
          });
      })
        .then(syncGift)
        .then(function () { return afterChange(message, type); })
        .then(function () { setBusy(false); })
        .catch(reportError);
    });
  }

  function removeCode(code) {
    return runExclusive(function () {
      setBusy(true);
      return getCart().then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
        return post('/cart/update.js', { discount: codes.join(',') }).then(function (r) { return r.json(); });
      })
        .then(syncGift)
        .then(function () { return afterChange(); })
        .then(function () { setBusy(false); })
        .catch(reportError);
    });
  }

  var noteTimer = null;
  function saveNote() {
    var ta = getRoot() && getRoot().querySelector('[data-asdc-note]');
    if (!ta) return Promise.resolve();
    clearTimeout(noteTimer);
    return post('/cart/update.js', { note: ta.value });
  }

  function checkout(btn) {
    btn.disabled = true;
    saveNote().then(function () { window.location.href = '/checkout'; }, function () { window.location.href = '/checkout'; });
  }

  /* ── Events ─────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var r = getRoot();
    if (!r) return;
    var t = e.target;

    // Header cart icon / any [data-asdc-open] opens the custom drawer
    var opener = t.closest('.cart-link, [data-asdc-open]');
    if (opener && !opener.closest('#asd-cart')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      runExclusive(function () { return getCart().then(syncGift).then(refresh); });
      return;
    }
    if (!t.closest('#asd-cart')) return;

    if (t.closest('[data-asdc-close]')) { close(); return; }

    var qtyBtn = t.closest('[data-asdc-qty]');
    if (qtyBtn) {
      var item = qtyBtn.closest('.asdc-item');
      var val = parseInt(item.querySelector('.asdc-qty__val').textContent, 10) || 1;
      var delta = parseInt(qtyBtn.dataset.asdcQty, 10);
      var max = parseInt(item.querySelector('.asdc-qty').dataset.max, 10);
      if (delta > 0 && max && val + delta > max) { showMsg('Only ' + max + ' available'); return; }
      changeLine(item.dataset.key, Math.max(0, val + delta));
      return;
    }
    var rm = t.closest('[data-asdc-remove]');
    if (rm) { changeLine(rm.closest('.asdc-item').dataset.key, 0); return; }

    var rc = t.closest('[data-asdc-remove-code]');
    if (rc) { removeCode(rc.dataset.asdcRemoveCode); return; }

    var add = t.closest('[data-asdc-add]');
    if (add) { addVariant(add.dataset.asdcAdd, add); return; }
    var addSel = t.closest('[data-asdc-add-select]');
    if (addSel) {
      var sel = addSel.closest('.asdc-card').querySelector('[data-asdc-variant]');
      addVariant(sel.value, addSel);
      return;
    }

    var prev = t.closest('[data-asdc-scroll-prev]');
    var next = t.closest('[data-asdc-scroll-next]');
    if (prev || next) {
      var tr = (prev || next).closest('.asdc-up').querySelector('[data-asdc-track]');
      tr.scrollBy({ left: (next ? 1 : -1) * tr.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    var co = t.closest('[data-asdc-checkout]');
    if (co) { checkout(co); }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-asdc-discount-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="code"]');
    applyCode(input.value);
    input.value = '';
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-asdc-note]')) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(saveNote, 800);
  });

  document.addEventListener('keydown', function (e) {
    var r = getRoot();
    if (!r || !r.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = r.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, summary');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Product added elsewhere on the site (product page, quick buy...) → sync gift, refresh, auto-open
  document.addEventListener('on:cart:add', function () {
    var r = getRoot();
    if (!r) return;
    if (r.dataset.autoOpen !== 'false') open();
    runExclusive(function () {
      setBusy(true);
      return getCart().then(syncGift).then(refresh).then(function () { setBusy(false); notifyChange(); }).catch(reportError);
    });
  });

  // Cart changed by something else (e.g. error path) → keep drawer in sync
  document.addEventListener('on:cart:change', function () {
    if (selfDispatch) return;
    runExclusive(function () { return getCart().then(syncGift).then(refresh); });
  });

  function init() {
    var inner = getInner();
    if (!inner) return;
    updateProgress();
    if (parseInt(inner.dataset.itemCount, 10) > 0) {
      runExclusive(function () {
        return getCart().then(syncGift).then(function (cart) {
          var shown = parseInt(getInner().dataset.itemCount, 10);
          if (cart.item_count !== shown) return refresh().then(notifyChange);
        });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.id && e.target.id.indexOf(SECTION_ID) !== -1) init();
  });

  // Public API
  window.asdCart = { open: open, close: close, refresh: function () { return runExclusive(refresh); } };
})();
